import React, { useState, useRef, useEffect } from 'react';
import './css/popup.css';
import { Translator, resources } from './Translator';
import { DiagLog } from './DiagLog';

const translator = new Translator(resources);

// 実機で発生した読み込み不具合を、PCに繋がずにコピペで送れるようにするための表示画面
const DiagLogPopup = ({ onClose }) => {
	const t = (key) => translator.t(key);
	const [text, setText] = useState('');
	const [isCopied, setIsCopied] = useState(false);
	const textareaRef = useRef(null);

	useEffect(() => {
		setText(DiagLog.getText());
	}, []);

	const handleRefresh = () => {
		setText(DiagLog.getText());
		setIsCopied(false);
	};

	const selectAll = () => {
		const el = textareaRef.current;
		if (!el) return false;
		el.focus();
		el.select();
		el.setSelectionRange(0, el.value.length);
		return true;
	};

	const handleCopy = async () => {
		const value = text;
		// 1) Clipboard API
		try {
			if (navigator.clipboard && window.isSecureContext) {
				await navigator.clipboard.writeText(value);
				setIsCopied(true);
				setTimeout(() => setIsCopied(false), 2000);
				return;
			}
		} catch (e) { /* 古いWebViewや未フォーカス時は下のフォールバックへ */ }

		// 2) execCommand フォールバック
		try {
			if (selectAll() && document.execCommand('copy')) {
				setIsCopied(true);
				setTimeout(() => setIsCopied(false), 2000);
				return;
			}
		} catch (e) { /* 3)へ */ }

		// 3) どちらも駄目な場合は全選択状態にして、長押し→コピーしてもらう
		selectAll();
	};

	const handleClear = () => {
		DiagLog.clear();
		setText(DiagLog.getText());
		setIsCopied(false);
	};

	return (
		<div className="popup" style={{ width: 'min(92vw, 720px)' }}>
			<span className="close_button" onClick={onClose}>&times;</span>
			<div className="popup-inner">
				<h2>{t('Diagnostics Log')}</h2>
				<textarea
					ref={textareaRef}
					value={text}
					readOnly
					onFocus={(e) => e.target.select()}
					style={{
						width: '100%',
						height: '50vh',
						fontFamily: 'monospace',
						fontSize: '11px',
						lineHeight: 1.4,
						whiteSpace: 'pre',
						color: '#111',
					}}
				/>
				<div>
					<button className='button_b' onClick={handleCopy}>
						{isCopied ? t('Copied!') : t('Copy All')}
					</button>
					<button className='button_b' onClick={handleRefresh}>{t('Refresh')}</button>
					<button className='button_b' onClick={handleClear}>{t('Clear Log')}</button>
					<button className='button_y' onClick={onClose}>{t('Close')}</button>
				</div>
			</div>
		</div>
	);
};

export default DiagLogPopup;
